module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isShow) ? _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "text-muted m-0 d-inline-flex form-control w-100 border-0 rounded stub",
    on: {
      "click": _vm.handleClickByStub
    }
  }, [_vm._v(_vm._s(_vm.placeholder) + "\n    ")]), _vm._v(" "), _c("caret", {
    tag: "component",
    attrs: {
      "options-count": _vm.optionsCount,
      "dropdown-list-count": _vm.dropdownListCount,
      "is-show-dropdown-list": _vm.isShowDropdownList,
      "on-show-dropdown-list": _vm.onShowDropdownList,
      "on-hide-dropdown-list": _vm.onHideDropdownList
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7faef644","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Stub.vue
// module id = 103
// module chunks = 0